// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    background: #444;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

}

#verticalButtons {
    display: flex;
    flex-direction: column;
}

#verticalInfo  {
    background-color:#333;
    min-width: 400px;
    min-height: 600px;
    display: flex;
    flex-direction: column;
    height: 100%;
    font-size: large;
    font-family: 'Courier New', Courier, monospace;
    font-weight: bold;
    color: white;

}

#verticalInfo div {
    padding: 20px;
}


input[type=text], input[type=password] {
    width: 200px;
    
    padding: 5px;
    margin-bottom: 25px;
    margin-top: 5px;
    border: 2px solid #ccc;
    color: #fff;
    font-size: 16px;
    border-radius: 5px;
    }

label{
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    }

#loginPanel  {
    background-color:#333;
    width: 300px;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    height: 100%;
    font-size: large;
    font-family: 'Courier New', Courier, monospace;
    font-weight: bold;
    color: white;

}

#loginPanel div {
    padding: 20px;
}

button {
    border: none;
    border-radius: 5px;
    padding: 10px;
    margin: 2px;
    cursor: pointer;
}

button:hover{
    background: lightgray;
}

#networkCanvas {
    background-color: #333;
}
#starterCanvas {
    background-color: #333;
}

#carCanvas {
    background: rgb(103, 95, 95);
}

#carCount {
    margin: 2px;
    width: 100px;
    font-size: x-large;
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,8CAA8C;IAC9C,iBAAiB;IACjB,YAAY;;AAEhB;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,YAAY;;IAEZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB;;AAEJ;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB;;AAEJ;IACI,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,8CAA8C;IAC9C,iBAAiB;IACjB,YAAY;;AAEhB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB","sourcesContent":["body {\r\n    margin: 0;\r\n    background: #444;\r\n    overflow: hidden;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n}\r\n\r\n#verticalButtons {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n#verticalInfo  {\r\n    background-color:#333;\r\n    min-width: 400px;\r\n    min-height: 600px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n    font-size: large;\r\n    font-family: 'Courier New', Courier, monospace;\r\n    font-weight: bold;\r\n    color: white;\r\n\r\n}\r\n\r\n#verticalInfo div {\r\n    padding: 20px;\r\n}\r\n\r\n\r\ninput[type=text], input[type=password] {\r\n    width: 200px;\r\n    \r\n    padding: 5px;\r\n    margin-bottom: 25px;\r\n    margin-top: 5px;\r\n    border: 2px solid #ccc;\r\n    color: #fff;\r\n    font-size: 16px;\r\n    border-radius: 5px;\r\n    }\r\n\r\nlabel{\r\n    color: #fff;\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    }\r\n\r\n#loginPanel  {\r\n    background-color:#333;\r\n    width: 300px;\r\n    min-height: 200px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n    font-size: large;\r\n    font-family: 'Courier New', Courier, monospace;\r\n    font-weight: bold;\r\n    color: white;\r\n\r\n}\r\n\r\n#loginPanel div {\r\n    padding: 20px;\r\n}\r\n\r\nbutton {\r\n    border: none;\r\n    border-radius: 5px;\r\n    padding: 10px;\r\n    margin: 2px;\r\n    cursor: pointer;\r\n}\r\n\r\nbutton:hover{\r\n    background: lightgray;\r\n}\r\n\r\n#networkCanvas {\r\n    background-color: #333;\r\n}\r\n#starterCanvas {\r\n    background-color: #333;\r\n}\r\n\r\n#carCanvas {\r\n    background: rgb(103, 95, 95);\r\n}\r\n\r\n#carCount {\r\n    margin: 2px;\r\n    width: 100px;\r\n    font-size: x-large;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
